import { render, staticRenderFns } from "./CustomPhoneInput.vue?vue&type=template&id=5688b13b&"
import script from "./CustomPhoneInput.vue?vue&type=script&lang=js&"
export * from "./CustomPhoneInput.vue?vue&type=script&lang=js&"
import style0 from "./CustomPhoneInput.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports